export default __webpack_public_path__ + "static/img20h-9dae637a1732dd8ffbfaaefa1e3017b5.jpg";